import script from "./FullPageLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullPageLoading.vue?vue&type=script&setup=true&lang=ts"

import "./FullPageLoading.vue?vue&type=style&index=0&id=f10bbd9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f10bbd9e"]])

export default __exports__